/* eslint-disable no-param-reassign */
import Vue from 'vue'
import VueDraggableResizable from '@/assets/js/vue-draggable-resizeable'
import '@/assets/js/vue-draggable-resizeable/components/vue-draggable-resizable.css'

// optionally import default styles
// import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

Vue.component('vue-draggable-resizable', VueDraggableResizable)
